<template>
  <div class="pt-2 manageshipment__wrapper2">
    <div
      class="_global__nodata d-flex justify-content-center align-items-center"
      v-if="inboundList && inboundList.length === 0"
    >
      <div class="text-center">
        <img src="@/assets/image/icon/nodata-older.svg" alt="" />
        <h4 class="pt-3">No archive found</h4>
      </div>
    </div>
    <div>
      <div
        v-for="item in inboundList"
        :key="item.id"
        class="bg-card-list mb-3 p-4 position-relative"
      >
        <div
          v-if="$route.params.type === 'in-storage' && item.isRequestOutStorage"
          :key="item.id"
          class="d-flex align-items-center justify-content-end position-absolute"
          style="top: 0; right: 0"
        >
          <div
            class="bg-info-main px-3 py-2 d-flex align-items-center justify-content-center"
            style="border-radius: 0px 8px 0px"
          >
            <span class="text-xs font-weight-bold italic text-white">
              Out Storage Request
            </span>
          </div>
        </div>
        <p class="col p-0 mb-3">
          <span class="pdetail__paragraph2"
            >Inbound ID : {{ item.inboundId || '' }}</span
          >
        </p>
        <div class="d-flex align-items-center pb-2 mt-2">
          <div class="col-10 p-0">
            <div class="d-flex mb-2">
              <p class="col-2 pdetail__paragraph1">Warehouse</p>
              <p class="col-3 d-flex align-items-start">
                <span class="pdetail__paragraph2 mr-1">:</span>
                <span class="pdetail__paragraph2">{{
                  item.warehouseName || '-'
                }}</span>
              </p>
              <p class="col-3 pdetail__paragraph1">Nomor Pengajuan</p>
              <p class="col-4 d-flex align-items-start">
                <span class="pdetail__paragraph2 mr-1">:</span>
                <span class="pdetail__paragraph2">{{
                  item.nomorPengajuan || '-'
                }}</span>
              </p>
            </div>
            <div class="d-flex mb-2">
              <p class="col-2 pdetail__paragraph1">Inbound Date</p>
              <p class="col-3 d-flex align-items-start">
                <span class="pdetail__paragraph2 mr-1">:</span>
                <span class="pdetail__paragraph2">{{
                  item.inboundDate ? getDateDefauld(item.inboundDate) : '-'
                }}</span>
              </p>
              <p class="col-3 pdetail__paragraph1">Reference Number</p>
              <p class="col-4 d-flex align-items-start">
                <span class="pdetail__paragraph2 mr-1">:</span>
                <span class="pdetail__paragraph2">{{
                  item.referenceNumber || '-'
                }}</span>
              </p>
            </div>
            <div class="d-flex">
              <p class="col-2 pdetail__paragraph1">Total SKU</p>
              <p class="col-3 d-flex align-items-start">
                <span class="pdetail__paragraph2 mr-1">:</span>
                <span class="pdetail__paragraph2">{{
                  item.totalSku || '-'
                }}</span>
              </p>
              <p class="col-3 pdetail__paragraph1">Total Inbound Quantity</p>
              <p class="col-4 d-flex align-items-start">
                <span class="pdetail__paragraph2 mr-1">:</span>
                <span class="pdetail__paragraph2">{{
                  item.storageQuantity ? item.storageQuantity : '-'
                }}</span>
              </p>
            </div>
          </div>
          <div class="col-2 p-0 ml-4">
            <button class="bluewhite mb-2" @click="seeDetail(item.id)">
              See Details
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixinDateTime from '@/mixin/getters/date-time'

export default {
  name: 'inventoryList',
  props: {
    inboundList: Array
  },
  mixins: [mixinDateTime],
  data() {
    return {}
  },
  methods: {
    seeDetail(id) {
      this.$router.push({
        name: 'inventoryDetail',
        params: {
          type: this.$route.params.type,
          id: id
        }
      })
    }
  }
}
</script>

<style lang="scss">
.redwhite {
  width: 150px;
  height: 36px;
  font-size: 12px;
  color: #c4232a;
  border: 1px solid #c4232a;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  background: #ffffff;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.011em;
}
.bluewhite {
  width: 150px;
  height: 36px;
  color: #fff;
  border: 1px solid #1d3354;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  background: #1d3354;
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: -0.011em;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouse/inventory/List.vue